import { createAction, props } from '@ngrx/store';

import { PaginatedLanguageList } from '@offconon/core-api';

import { LanguageDropdownEntity } from './language-dropdown.models';

export const initLanguageDropdown = createAction('[LanguageDropdown Page] Init');

export const loadLanguageDropdownSuccess = createAction(
  '[LanguageDropdown/API] Load LanguageDropdown Success',
  props<{ languageDropdown: LanguageDropdownEntity[] }>(),
);

export const loadLanguageDropdownFailure = createAction(
  '[LanguageDropdown/API] Load LanguageDropdown Failure',
  props<{ error: any }>(),
);

export const fetchLanguages = createAction(
  '[LanguageDropdown/API] Fetch Language',
  props<{ page?: number; pageSize?: number; searchJson?: {}; dropdownId?: string }>(),
);

export const fetchLanguagesSuccess = createAction(
  '[LanguageDropdown/API] Fetch Language Success',
  props<{ languageResponse: PaginatedLanguageList; dropdownId?: string }>(),
);

export const searchLanguage = createAction(
  '[LanguageDropdown/API] Search Language',
  props<{ searchJson?: {}; dropdownId?: string }>(),
);
